<template >
  <div style="padding-left: 5px" >
    <div v-if="objType=='array'" >
      <div
          class="array_line"
          v-for="(child,idx) in content"
          :key="idx" >
        <JsonExplorer :json-obj="child" ></JsonExplorer >
      </div >
    </div >
    <div v-else-if="objType=='object'" >
      <el-row
          v-for="(child,idx) in content"
          :key="idx" >
        <el-col
            class="obj_line"
            :md="8"
            v-html="idx" ></el-col >
        <el-col
            :md="16"
            class="obj_line" >
          <JsonExplorer :json-obj="child" ></JsonExplorer >
        </el-col >
      </el-row >
    </div >
    <div
        v-else
        v-html="content" ></div >
  </div >
</template >

<script >
export default {
  name: "JsonExplorer",
  props: {
    jsonString: {type: String, default: null},
    jsonObj: {
      type: [String,
             Boolean,
             Number,
             Object], default: () => null
    }
  },
  created() {
    if (this.jsonString) this.content = JSON.parse(this.jsonString)
  },
  data() {
    return {
      content: null
    };
  },
  computed: {
    objType() {

      if (_.isArray(this.content)) return 'array'
      if (_.isObject(this.content)) return 'object'
      return 'leaf'
    }
  },
  methods: {},
  watch: {
    jsonString: {
      handler(val, oldval) {

        if (!this.content && val) {
          this.content = JSON.parse(val)
          _log_('jsonString', this.content, this.objType)
          return;
        }
        if (val == oldval) return;
        if (val)
          this.content = JSON.parse(val)
      },
      immediate: true,
    },

    jsonObj: {
      handler(val, oldval) {
        if (JSON.stringify(val) == JSON.stringify(this.content)) return;
        if (val == 'true' || val === true) this.content = '<span class="material-icons">check</span>'
        else if (val == 'false' || val === false) this.content = '<span class="material-icons">close</span>'
        else
          this.content = val
      },
      immediate: true,
    },
  }
}
</script >

<style >
div.array_line {
  box-shadow: 0px 0px 1px;
  padding: 5px;
  margin: 5px;
}

div.obj_line {
  border-bottom: dashed 1px #e0c5c5;
}
</style >
